module.exports = __webpack_public_path__ + "static/img/intro.9664f21b.png";